import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const SecuredRoute = ({
  component: Component,
  security,
  errors,
  roles,
  ...otherProps
}) => (
  <Route
    {...otherProps}
    render={(props) => {
      if (security.validToken === true) {
       
        // check if route is restricted by role
        if (roles && !roles.some(v=>security.user.roles.includes(v))) {
         
          // role not authorised so redirect to home page
          return <Redirect to={{ pathname: "/home" }} />;
        }
      } else {
      return  <Redirect to="/login" />;
      }

      return <Component {...props} />;
    }}
  />
);

SecuredRoute.propTypes = {
  security: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  security: state.security,
  errors: state.errors,
});

export default connect(mapStateToProps)(SecuredRoute);
